import { Component, ViewChild, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MembershipService, UserService, AddressService, AccommodationService } from 'services';
import { MembershipPricingTier, AuthOnly, Country, Accommodation, AccommodationCreate } from 'models';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-add-membership-listing',
    template: require('./add-membership-listing.component.html'),
    styles: [require('./add-membership-listing.component.scss')],
    host: { class: "flex flex-col flex-1 overflow-hidden mt-16 lg:mt-0" }
})

export class AddMembershipListingComponent implements OnInit {
    d1: string; d2: string; d3: string; d4: string; d5: string; d6: string;
    currentStep: number = 1;

    newAccommodation: AccommodationCreate = new AccommodationCreate();
    accommodation: Accommodation = new Accommodation({});

    monthlyPricingTier: MembershipPricingTier = new MembershipPricingTier();
    yearlyPricingTier: MembershipPricingTier = new MembershipPricingTier();
    selectedPricingTierId: number = this.yearlyPricingTier.id;

    acquiredPostUrl: string = environment.acquiredUrl;
    authOnly: AuthOnly = new AuthOnly();
    acquiredUrlError: boolean = false;
    authError: boolean = false;
    hasPaymentDetails: boolean = false;

    countries: Country[];
    otherCountries: Country[] = new Array<Country>();
    popularCountries: Country[] = new Array<Country>();

    public showMonthly: boolean = true;
    public showYearly: boolean = false;
    monthlyActive: boolean = true;
    yearlyActive: boolean = false;

    @ViewChild('acquiredForm') acquiredForm;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        private membershipService: MembershipService,
        private userService: UserService,
        private addressService: AddressService,
        public accommodationService: AccommodationService
    ) {
        (<any>window).onMessage = this.onMessage.bind(this);
    }

    @HostListener('window:message', ['$event'])
    onMessage(e) {
        this.receiveMessage(e);
    }

    ngOnInit() {
        this.newAccommodation.accommodation = this.accommodation;

        this.addressService.getCountries().subscribe(r => {
            this.countries = r;
            this.popularCountries = this.countries.filter(f => f.name === "United Kingdom" || f.name === "United States");
            this.otherCountries = this.countries.filter(f => f.name !== "United Kingdom" && f.name !== "United States");
        });

        this.membershipService.getPricingTiers().subscribe(r => {
            this.monthlyPricingTier = r.find(p => p.paymentOptionId === 3);
            this.yearlyPricingTier = r.find(p => p.paymentOptionId === 4);
            this.selectedPricingTierId = this.monthlyPricingTier.id;
        });

        this.membershipService.hasPaymentDetails().subscribe(r => {
            this.hasPaymentDetails = r;
        });
    }

    getHash() {
        this.membershipService.getAuthOnly(`sm-${this.selectedPricingTierId}`, 0).subscribe(result => {
            this.authOnly = result;
            setTimeout(_ => this.acquiredForm.nativeElement.submit(), 1);
        },
            () => { this.acquiredUrlError = true; });
    }

    tryAgain() {
        this.authError = false;
        this.getHash();
    }

    receiveMessage(message: any) {
        //If success create payment verification send message data response
        if (message.data.response) {
            if (message.data.response.code === "1" || message.data.response.code === "262") {
                this.nextStep(null);
            } else {
                this.authError = true;
            }
        }
    }

    prevStep() {
        this.currentStep--;
    }

    nextStep(form: NgForm) {
        if (form && form.valid) {
            this.currentStep++;
        } else if (!form) {
            this.currentStep++;
        }

        if (this.currentStep === 2) {
            if (this.hasPaymentDetails) {
                this.currentStep = 3;
            } else {
                this.getHash();
            }
        }
    }

    addAccommodation(form: NgForm) {
        if (form.valid) {
            this.membershipService.createMembership(this.selectedPricingTierId).subscribe(() => {
                this.accommodationService.create(this.newAccommodation).subscribe(r => {
                    this.userService.refreshUserToken().subscribe(u => {
                        this.router.navigate(['/host/dashboard/', { outlets: { section: ['listings'] } }]);
                    });
                });
            });
        }
    }

    toggle() {
        this.showYearly = !this.showYearly;
        this.showMonthly = !this.showMonthly;
        this.monthlyActive = !this.monthlyActive;
        this.yearlyActive = !this.yearlyActive;

        if (this.showYearly) {
            this.selectedPricingTierId = this.yearlyPricingTier.id
        } else {
            this.selectedPricingTierId = this.monthlyPricingTier.id
        }
    }
}
